var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion"},[_c('pdf',{attrs:{"src":_vm.company_monthly_file.url_file}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }